






























import {Component, Prop, Vue} from 'vue-property-decorator';
import PaymentJobRunningComponent from '@/components/payment/payment-job-running.vue';
import SlideBarComponents from '@/components/layout/SlideBar.vue';

@Component({
  components: {
    PaymentJobRunningComponent,
    SlideBarComponents
  }
})
export default class BgTheme1 extends Vue {
}
